<header class="dlg-h">
    <div class="dlg-meta">
        <h2>Eventos</h2>
        <p>
            <span class="name">{{ data.animalName }}</span>
            @if (data.animalRegister) {
            <span class="reg">{{ data.animalRegister }}</span>
            }
        </p>
    </div>
    <button type="button" mat-icon-button (click)="onClose()" aria-label="Fechar">
        <mat-icon>close</mat-icon>
    </button>
</header>

@if (!isLoading && !hasError && (historyEvents.length > 0 || milkingGroups.length > 0)) {
<nav class="tabs" role="tablist">
    <button
        type="button"
        role="tab"
        [attr.aria-selected]="tab === 'history'"
        [class.on]="tab === 'history'"
        (click)="setTab('history')"
    >
        Histórico
        <em>{{ historyEvents.length }}</em>
    </button>
    <button
        type="button"
        role="tab"
        [attr.aria-selected]="tab === 'milking'"
        [class.on]="tab === 'milking'"
        (click)="setTab('milking')"
    >
        Controles
        <em>{{ milkingGroups.length }}</em>
    </button>
</nav>
}

<div class="dlg-body">
    @if (isLoading) {
    <div class="state">
        <mat-spinner diameter="28"></mat-spinner>
    </div>
    } @else if (hasError) {
    <div class="state error">
        <mat-icon>error_outline</mat-icon>
        <span>Não foi possível carregar os eventos.</span>
        <button type="button" mat-stroked-button color="primary" (click)="loadEvents()">Tentar de novo</button>
    </div>
    } @else if (historyEvents.length === 0 && milkingGroups.length === 0) {
    <div class="state empty">
        <mat-icon>event_busy</mat-icon>
        <span>Nenhum evento registrado.</span>
    </div>
    } @else if (tab === 'history') {
    @if (historyEvents.length === 0) {
    <div class="state empty">
        <mat-icon>history</mat-icon>
        <span>Sem eventos reprodutivos/saída.</span>
        <button type="button" class="linkish" (click)="setTab('milking')">Ver controles</button>
    </div>
    } @else {
    <div class="timeline">
        @for (event of historyEvents; track event.id || event) {
        <div class="ev">
            <span class="rail">
                <span class="icon-wrap" [style.border-color]="event.color">
                    @if (event.iconPath) {
                    <img [src]="event.iconPath" [alt]="event.label" width="28" height="28" />
                    } @else {
                    <span class="dot" [style.backgroundColor]="event.color"></span>
                    }
                </span>
            </span>
            <div class="ev-card" [style.border-left-color]="event.color">
                <b>{{ event.label }}</b>
                <small>{{ event.date | date: 'dd/MM/yyyy':'UTC' }}</small>
            </div>
        </div>
        }
    </div>
    }
    } @else {
    <div class="milk-panel">
        @if (milkingByYear.length === 0) {
        <div class="state empty">
            <mat-icon>water_drop</mat-icon>
            <span>Nenhum controle leiteiro neste animal.</span>
        </div>
        } @else {
        <div class="year-list">
            @for (bucket of milkingByYear; track bucket.year) {
            <section class="year-block" [class.open]="bucket.open">
                <button
                    type="button"
                    class="year-h"
                    [attr.aria-expanded]="bucket.open"
                    (click)="toggleYear(bucket)"
                >
                    <span class="year-label">{{ bucket.year }}</span>
                    <span class="year-chev" aria-hidden="true">
                        <mat-icon>{{ bucket.open ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </span>
                </button>
                @if (bucket.open) {
                <div class="ctrl-table" role="table">
                    <div class="ctrl-head" role="row">
                        <span role="columnheader">Controle</span>
                        <span role="columnheader">Origem</span>
                        <span role="columnheader">Início</span>
                        <span role="columnheader">Fim</span>
                    </div>
                    @for (group of bucket.items; track group.key) {
                    <div class="ctrl-row static" role="row">
                        <span class="ctrl-month" role="cell">
                            <b>{{ group.label }}</b>
                        </span>
                        <span class="ctrl-origin" role="cell">
                            <span class="pill" [class]="originClass(group.origin)">{{
                                group.originLabel
                            }}</span>
                        </span>
                        <span class="ctrl-period" role="cell">{{ group.fromLabel }}</span>
                        <span class="ctrl-period" role="cell">{{ group.toLabel }}</span>
                    </div>
                    }
                </div>
                }
            </section>
            }
        </div>
        }
    </div>
    }
</div>

@if (!isLoading && (historyEvents.length > 0 || milkingGroups.length > 0)) {
<footer class="dlg-f">
    <span class="count"
        >{{ historyEvents.length }} no histórico
        · {{ milkingGroups.length }} controle{{ milkingGroups.length === 1 ? '' : 's' }}</span
    >
    <button type="button" mat-stroked-button (click)="onClose()">Fechar</button>
</footer>
}
